import Divider from '@zenbusiness/zui/Divider';
import Skeleton from '@zenbusiness/zui/Skeleton';
import { styled } from '@zenbusiness/zui/styles';

import { StatementSkeletonStyle, DividerStyle } from './styles';

const StatementSkeletonStyled = styled(Skeleton)(StatementSkeletonStyle);
const DividerStyled = styled(Divider)(DividerStyle);

const StatementSkeleton = () => (
  <>
    <DividerStyled />
    <StatementSkeletonStyled variant="rectangular" />
  </>
);

export default StatementSkeleton;
